import SentryService, { SentryInitOptions, SentryLogOptions } from '../sentry';

type LogOptions = Pick<SentryLogOptions, 'extra' | 'tags'>;

class Logger {
  errorService: any;

  constructor({ errorServiceOptions }: { errorServiceOptions: SentryInitOptions }) {
    this.errorService = new SentryService(errorServiceOptions || {});
  }

  error(error: Error | string, options?: LogOptions): void {
    this.errorService.log(error, { ...(options || {}), level: 'error' });
  }

  warning(error: Error | string, options?: LogOptions): void {
    this.errorService.log(error, { ...(options || {}), level: 'warning' });
  }

  info(message: string, options?: LogOptions): void {
    // eslint-disable-next-line no-console
    console.log({ message, options });
  }
}

export default Logger;
